import { acronisProductCodes as acronisBackupsProductCodes } from 'utility/acronisProductMap';

/**
 * Product codes of the add-ons a customer can order for a server. An ordered
 * cart item only counts as an add-on when its product code is in this list.
 */
export const ADD_ON_PRODUCT_CODES = [
	...acronisBackupsProductCodes,
	'AcronisEDR',
	'DDoS.Server.Protect',
	'ServerSecurity.Imunify360',
	'ServerSecurity.ThreatDown',
];

export default ADD_ON_PRODUCT_CODES;
